import React from 'react';

export default function Spinner({ inverted }) {
  const classes = inverted ? 'inverted' : '';

  return (
    <div className="lds-ring">
      <div className={classes}></div>
      <div className={classes}></div>
      <div className={classes}></div>
      <div className={classes}></div>
    </div>
  );
}
